<template>
	<b-modal centered hide-footer title="Fechas clasificadas" size="xmd" v-model="isActive" @hidden="handleHidden">
		<b-overlay :show="isLoading">
			<b-table-simple sticky-header="60vh">
				<b-thead class="text-center">
					<b-tr>
						<b-th>Torneo</b-th>
						<b-th>Fecha</b-th>
						<b-th class="text-nowrap">Etapa proveniente</b-th>
						<b-th>Acciones</b-th>
					</b-tr>
				</b-thead>
				<b-tbody class="text-center">
					<b-tr v-for="row in rows" :key="row.id">
						<b-td>
							<ViewImage
								v-b-tooltip.hover
								:specimen="{
									id: 1,
									url: row.url_image,
								}"
							/>
							<div>
								{{ row.date.tournament }}
							</div>
						</b-td>
						<b-td>{{ row.date.date | myGlobalDayShort }}</b-td>
						<b-td>{{ row.date.stage }}</b-td>
						<b-td>
							<div class="d-flex">
								<b-button
									class="text-nowrap"
									variant="outline-primary"
									@click="
										;(completePending.show = !completePending.show), (completePending.info = row)
									"
								>
									Siguiente etapa
								</b-button>
								<b-button
									variant="flat-danger"
									@click="deletePendingEvent(row.id)"
									v-b-tooltip.hover
									title="Eliminar fecha clasificada"
								>
									<FeatherIcon icon="Trash2Icon" size="18" class="text-danger" />
								</b-button>
							</div>
						</b-td>
					</b-tr>
					<b-tr v-if="rows.length == 0">
						<b-td colspan="4">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
		<MassiveEventsModal
			:show="completePending.show"
			:info="completePending.info"
			@closing="completePending.show = false"
			@refresh="getRows(), $emit('refresh')"
			:disabled_price_zero="true"
			:season="{ id: null, start: null, end: null }"
		/>
	</b-modal>
</template>

<script>
import tournamentService from "@/services/tournament/default.service"
import MassiveEventsModal from "./MassiveEventsModal.vue"
import CompletePendingModal from "./CompletePendingModal.vue"
import ViewImage from "@/components/commons/ViewImage.vue"
import { mapActions } from "vuex"
export default {
	components: { CompletePendingModal, MassiveEventsModal, ViewImage },
	props: {
		show: Boolean,
		info: Object,
		season: Object,
	},
	data: () => ({
		isActive: false,
		isLoading: false,
		rows: [],
		completePending: {
			show: false,
			info: {},
		},
	}),
	computed: {},
	methods: {
		...mapActions({
			A_PENDING_EVENTS_COUNTER: "counters/A_PENDING_EVENTS_COUNTER",
		}),
		handleHidden() {
			this.isActive = false
			this.isLoading = false
			this.$emit("closing")
		},
		async deletePendingEvent(id) {
			this.isLoading = true
			try {
				const { isConfirmed } = await this.showConfirmSwal({
					text: `¿Estás seguro de eliminar esta fecha clasificada?`,
				})
				if (!isConfirmed) return
				await tournamentService.deletePendingEvent(id)
				this.getRows()
				this.A_PENDING_EVENTS_COUNTER()
				this.showToast(
					"success",
					"top-right",
					"Éxito",
					"CheckCircleIcon",
					"Fecha clasificada eliminada correctamente"
				)
			} catch (error) {
				this.showToast("danger", "top-right", "Error", "XIcon", "Error al eliminar la fecha clasificada")
			} finally {
				this.isLoading = false
			}
		},
		async getRows() {
			this.isLoading = true
			const { data } = await tournamentService.getPendingEvents()
			this.rows = data
			this.isLoading = false
			if (data.length == 0) {
				this.handleHidden()
			}
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.isActive = val
				this.getRows()
			}
		},
	},
}
</script>
